export default {
    BASE_URL: 'pc/crm/mem',
    api: [
        {
            name: 'pendingList',
            desc: '获取待审核列表',
            method: 'GET',
            path: '/audit/pending/list',
        },
        {
            name: 'completedList',
            desc: '获取已审核列表',
            method: 'GET',
            path: '/audit/list',
        },
        {
            name: 'detail',
            desc: '获取审核详情',
            method: 'GET',
            path: '/audit/detail'
        },
        {
            name: 'notpass',
            desc: '审核不通过',
            method: 'POST',
            path: '/audit/reject',
        },
        {
            name: 'pass',
            desc: '审核通过',
            method: 'POST',
            path: '/audit/pass'
        },
        {
            name: 'feeRule',
            desc: '缴费标准',
            method: 'GET',
            path: '/fee/rule'
        },
        {
            name: 'addReview',
            desc: '新增审议信息',
            method: 'POST',
            path: '/audit/review'
        },
        {
            name: 'reviewDetail',
            desc: '查看审议信息',
            method: 'GET',
            path: '/audit/review/info'
        },
        {
            name: 'exportExcelAuditList',
            desc: '导出入会审核信息',
            method: 'POST',
            path: '/audit/list/export'
        }
    ]
}


// WEBPACK FOOTER //
// ./src/api/member/initiation.js